export default __webpack_public_path__ + "static/media/flag-uk.ed837630.svg";